import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";

import { css } from "styled-components";

logoStyles.wrapper = mergeToNew(logoStyles.wrapper, {
    width: 12,
    css: css`
        max-width: 100%;
        & img {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 5px;
                            max-width: 280px;
                        `,
                        css`
                            margin-top: 5px;
                            max-width: 280px;
                        `,
                        css`
                            margin-top: 5px;
                            max-width: 100%;
                        `,
                        css`
                            margin-top: 5px;
                            max-width: 100%;
                        `,
                    ],
                    "min",
                )}
            height: auto !important;
        }
    `,
});
